import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

function UnauthorizedTemplate({ rootStore }) {
    return (
        <section>
            <div className='login__top'>
                <img className='login__top__logo' src={require('themes/assets/img/logo.svg')} alt='Logo' />
            </div>
            <div className='container--login'>
                <div className='form card card--lrg card--primary type--center'>
                    <h1 className='u-mar--bottom--med type--wgt--bold type--color--primary'>You are not authorized to view selected content.</h1>
                        <div>
                            <img className="w--200--px u-mar--bottom--med" src={require('themes/assets/img/schedule.svg')} alt='Error'/>
                        </div>
                        <button  className='btn btn--base btn--primary'  onClick={() => rootStore.routerStore.goTo(rootStore.initialState)}>
                            Home
                        </button>
                </div>
            </div>
        </section>
    );
}

UnauthorizedTemplate.propTypes = {
    rootStore: PropTypes.object.isRequired
 };

export default defaultTemplate(UnauthorizedTemplate);
